export const setColors = (colors) => {
  const HTML = document.querySelector('html')

  if (colors !== null && HTML) {
    Object.keys(colors).forEach((key) => {
      const variableName = key.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()
      HTML.style.setProperty(`--${variableName}`, colors[key])
    })
  }
}
